import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { obtenerPerfil, actualizarPerfil } from "../api";
import { toast } from "react-hot-toast";
import "../assets/css/style.css";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const ActualizarDatos = () => {
  const { user, authReady } = useAuth();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [celular, setCelular] = useState("");
  const [usuario, setUsuario] = useState("");
  const [loadingPerfil, setLoadingPerfil] = useState(true);
  const showSplash = useDynamicSplash(loadingPerfil);

  useEffect(() => {
    if (!authReady) return;
    if (!user?.id) {
      navigate("/login", { replace: true });
    } else {
      window.history.replaceState({}, "", "/perfil");
      window.history.pushState({}, "", "/actualizardatos");
    }
  }, [authReady, user]);

  useEffect(() => {
    if (!authReady) return;
    if (!user?.id) {
      navigate("/login", { replace: true });
    }
  }, [authReady, user]);

  useEffect(() => {
    let mounted = true;
    const cargarPerfil = async () => {
      if (!authReady || !user?.id) return;
      setLoadingPerfil(true);
      document.body.style.overflow = "hidden";

      try {
        const res = await obtenerPerfil(user.id);
        if (!mounted) return;

        if (res?.nombre) {
          setNombre(res.nombre || "");
          setCorreo(res.correo || "");
          setCelular(res.telefono !== null && res.telefono !== undefined ? String(res.telefono) : "");
          setUsuario(res.usuario || "");
        } else {
          toast.dismiss();
          toast.error("No se pudo cargar tu perfil.");
        }
      } catch (err) {
        if (!mounted) return;
        toast.dismiss();
        toast.error("Error al obtener perfil.");
      } finally {
        if (mounted) {
          setLoadingPerfil(false);
          document.body.style.overflow = "auto";
        }
      }
    };

    cargarPerfil();
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, [authReady, user]);

  const handleActualizar = async () => {
    if (!nombre || !usuario) {
      toast.dismiss();
      toast.error("Todos los campos son obligatorios.");
      return;
    }

    const result = await actualizarPerfil({
      id_perfil: user.id,
      nombre,
      correo,
      telefono: celular,
      usuario,
    });

    if (result.success) {
      toast.dismiss();
      toast.success("Perfil actualizado correctamente.");
      navigate("/perfil");
    } else {
      toast.dismiss();
      toast.error(result.message || "El usuario o correo ya están en uso.");
    }
  };

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}

      {!showSplash && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <div className="app-container">
            <div className="promo-container">
              <div className="promo-header"></div>
              <div className="promo-banner">
                <img src="/assets/images/portada.jpg" alt="Portada" style={{ borderRadius: 0 }} />
              </div>
              <div className="promo-info" style={{ padding: 0 }}>
                <div className="login-body">
                  <div className="connections-container">
                    <div className="back-container mt-25">
                      <button
                        className="back-btn"
                        onClick={() => navigate("/perfil", { replace: true })}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                          <path
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="48"
                            d="M244 400L100 256l144-144M120 256h292"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <img
                    src="/assets/images/logocap.png"
                    alt="Logo"
                    style={{ paddingTop: 10 }}
                    className="login-logo"
                  />
                  <h2>Actualiza tus datos</h2>
                  <p className="light-text mb-5">¿Tu información ha cambiado? Actualízala aquí.</p>

                  <div className="input-group">
                    <label>Nombre:</label>
                    <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                  </div>

                  <div className="input-group">
                    <label>Correo: <small>(Opcional)</small></label>
                    <input type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} />
                  </div>

                  <div className="input-group">
                    <label>Celular: <small>(Opcional)</small></label>
                    <input type="tel" value={celular} onChange={(e) => setCelular(e.target.value)} />
                    <small></small>
                  </div>

                  <div className="input-group">
                    <label>Usuario:</label>
                    <input type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)} />
                  </div>

                  <button className="login-btn" onClick={handleActualizar}>
                    Guardar cambios
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default ActualizarDatos;
